import { Controller } from "@hotwired/stimulus"

// Turbo Stream broadcasts (Recording#broadcast_admin_row/broadcast_student_row)
// insert/remove rows directly into the list target, without touching the
// count text or empty-state banner elsewhere on the page — this keeps both
// in sync with the list's actual children.
export default class extends Controller {
  static targets = ["list", "count", "empty"]
  static values = { noun: { type: String, default: "Recording" } }

  connect() {
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.listTarget, { childList: true })
    this.sync()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  sync() {
    const count = this.listTarget.children.length

    if (this.hasCountTarget) {
      this.countTarget.textContent = `Displaying ${count} ${this.nounValue}${count === 1 ? "" : "s"}`
    }
    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = count > 0
    }
  }
}
